import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DnsSentinel, DnsSentinelResponseData } from '../api/domainTest/domainTest.interface'

type DomainTestState = {
  detailedResultData: DnsSentinelResponseData
  isEventSourceActive: boolean
  errorMessage?: string
  closeEventSource?: () => void
}
const initialState: DomainTestState = {
  detailedResultData: {
    features: {
      [DnsSentinel.CLASSIFICATION]: null,
      [DnsSentinel.DNS]: null,
      [DnsSentinel.GEO_IP]: null,
      [DnsSentinel.HTTP]: null,
      [DnsSentinel.NET_LOG]: null,
      [DnsSentinel.SCREENSHOT]: null,
      [DnsSentinel.TLS]: null,
      [DnsSentinel.WHO_IS]: null,
    },
  },
  isEventSourceActive: false,
}
export const domainTestSlice = createSlice({
  name: 'domainTest',
  initialState: {
    ...initialState,
  },
  reducers: {
    setDetailedResultData: (state, action: PayloadAction<DnsSentinelResponseData>) => {
      if (state.detailedResultData && state.detailedResultData?.features) {
        state.detailedResultData.features = {
          ...state.detailedResultData.features,
          ...action.payload.features,
        }
      }

      if (!state.detailedResultData) {
        state.detailedResultData = action.payload
      }
    },
    setIsEventSourceActive(state, { payload }: PayloadAction<boolean>): void {
      state.isEventSourceActive = payload
    },
    setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
      state.errorMessage = action.payload
    },
    closeEventSourceHandler(state, { payload }: PayloadAction<() => void | undefined>): void {
      state.closeEventSource = payload
    },
    resetStreaming: state => {
      state.detailedResultData = initialState.detailedResultData
      state.isEventSourceActive = false
      state.closeEventSource?.()
      state.closeEventSource = undefined
    },
  },
})

export const {
  setDetailedResultData,
  setIsEventSourceActive,
  setErrorMessage,
  resetStreaming,
  closeEventSourceHandler,
} = domainTestSlice.actions
